import { c as _c } from "react/compiler-runtime";
import { Image } from '@/components/client';
interface ImageSectionProps {
  url: string;
  title: string;
  description: string[];
  alt: string;
}
export const ImageSection = t0 => {
  const $ = _c(11);
  const {
    url,
    title,
    description,
    alt
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <h2 className="sr-only">{title}</h2>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== description) {
    t2 = description.map(_temp);
    $[2] = description;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== alt || $[5] !== url) {
    t3 = <Image src={url} alt={alt} width={850} height={600} className="w-full" />;
    $[4] = alt;
    $[5] = url;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t1 || $[8] !== t2 || $[9] !== t3) {
    t4 = <section className="flex flex-col">{t1}{t2}{t3}</section>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
function _temp(description_0, index) {
  return <p key={index} className="sr-only">{description_0}</p>;
}